$(document).ready(() => {
        console.log('in jquery')
        // Constants
        const DEFAULT_ROLL_WIDTH = 23; // Inches


        const PARAM_ROLL_WIDTH = 'width';

        // Parameters
        const params = new URLSearchParams(window.location.search);

        // Globals
        let areValuesInRoyal = true;

        // Elements
        const FORM = $('#calculator-form');

        const INPUT_UNITS = $('#calc-field-units');
        const INPUT_ROLL_WIDTH = $('#calc-field-roll-width');
        const FIELD_ROLL_LENGTH = $('#form-field-roll-length');
        const INPUT_ROLL_LENGTH = $('#calc-field-roll-length');
        const FIELD_AREA_DIMENSIONS = $('#name-form-field-dimensions');
        const INPUT_AREA_WIDTH = $('#calc-field-area-width');
        const INPUT_AREA_HEIGHT = $('#calc-field-area-height');
        const FIELD_PATTERN = $('#form-field-pattern');
        const INPUT_PATTERN = $('#calc-field-pattern');

        const INPUT_BUTTON = $('#calc-button');

        const TEXT_UNIT_BG = $('.calc-unit-bg');
        const TEXT_UNIT_SM = $('.calc-unit-sm');
        const TEXT_DISCLAIMER = $('#calc-disclaimer');

        const royalToMetric = (value, isBig) => isBig ? value * 0.3048 : value * 2.54;

        const metricToRoyal = (value, isBig) => isBig ? value / 0.3048 : value / 2.54;

        const getSmallUnit = () => areValuesInRoyal ? 'inches' : 'centimetres';

        const getBigUnit = () => areValuesInRoyal ? 'feet' : 'metres';

        const roundToMultiplee = (value, multiple) => multiple * Math.ceil(value / multiple);

        const displayNumber = value => Math.round((value + Number.EPSILON) * 100) / 100;

        const replaceUnits = value => {

            if (areValuesInRoyal && value === 'in') {
                return;
            }
            if (!areValuesInRoyal && value !== 'in') {
                return;
            }

            areValuesInRoyal = value === 'in';
            TEXT_UNIT_SM.text(getSmallUnit());
            TEXT_UNIT_BG.text(getBigUnit());

            INPUT_ROLL_LENGTH.find("option").each((index, element) => {
                const numValue = parseFloat($(element).val());
                if (areValuesInRoyal) {
                    $(element).text(displayNumber(numValue) + ' ' + getBigUnit());
                } else {
                    $(element).text(displayNumber(royalToMetric(numValue, true)) + ' ' + getBigUnit());
                }
            });
            const areaWidthValue = parseFloat(INPUT_AREA_WIDTH.val());
            if (areaWidthValue && !isNaN(areaWidthValue)) {
                if (areValuesInRoyal) {
                    INPUT_AREA_WIDTH.val(displayNumber(metricToRoyal(areaWidthValue, false)));
                } else {
                    INPUT_AREA_WIDTH.val(displayNumber(royalToMetric(areaWidthValue, false)));
                }
            }
            const areaHeightValue = parseFloat(INPUT_AREA_HEIGHT.val());
            if (areaHeightValue && !isNaN(areaHeightValue)) {
                if (areValuesInRoyal) {
                    INPUT_AREA_HEIGHT.val(displayNumber(metricToRoyal(areaHeightValue, false)));
                } else {
                    INPUT_AREA_HEIGHT.val(displayNumber(royalToMetric(areaHeightValue, false)));
                }
            }
            const patternHeightValue = parseFloat(INPUT_PATTERN.val());
            if (patternHeightValue && !isNaN(patternHeightValue)) {
                if (areValuesInRoyal) {
                    INPUT_PATTERN.val(displayNumber(metricToRoyal(patternHeightValue, false)));
                } else {
                    INPUT_PATTERN.val(displayNumber(royalToMetric(patternHeightValue, false)));
                }
            }
        };

        const getResults = () => {

            const res = {
                valuesInRoyal: areValuesInRoyal,
                strips: {},

            };

            //All this in CM
            const areaWidthValue = parseFloat(INPUT_AREA_WIDTH.val());
            if (!areaWidthValue || isNaN(areaWidthValue)) {
                return {
                    error: FIELD_AREA_DIMENSIONS
                };
            }
            const areaWidth = areValuesInRoyal ? royalToMetric(areaWidthValue, false) : areaWidthValue;
            const areaHeightValue = parseFloat(INPUT_AREA_HEIGHT.val());
            if (!areaHeightValue || isNaN(areaHeightValue)) {
                return {
                    error: FIELD_AREA_DIMENSIONS
                };
            }
            const areaHeight = areValuesInRoyal ? royalToMetric(areaHeightValue, false) : areaHeightValue;

            const rollWidthValue = parseFloat(INPUT_ROLL_WIDTH.val());
            if (!rollWidthValue || isNaN(rollWidthValue)) {
                return {
                    error: FIELD_ROLL_LENGTH
                };
            }
            const rollWidth = royalToMetric(rollWidthValue, false);

            const rollLengthValue = parseFloat(INPUT_ROLL_LENGTH.val());
            if (!rollLengthValue || isNaN(rollLengthValue)) {
                return {
                    error: FIELD_ROLL_LENGTH
                };
            }
            const rollLength = royalToMetric(rollLengthValue, true) * 100;
            const patternRepeatValue = parseFloat(INPUT_PATTERN.val());
            if (!patternRepeatValue || isNaN(patternRepeatValue)) {
                return {
                    error: FIELD_PATTERN
                };
            }
            const patternRepeat = areValuesInRoyal ? royalToMetric(patternRepeatValue, false) : patternRepeatValue;

            const stripCount = Math.ceil(areaWidth / rollWidth);

            res.strips.normal = {
                length: roundToMultiplee(areaHeight, patternRepeat),
                amount: stripCount
            };

            res.totalLength = 0;
            for (let type in res.strips) {
                if (res.strips.hasOwnProperty(type)) {
                    res.totalLength += res.strips[type].amount * res.strips[type].length;
                }
            }

            res.rolls = Math.ceil(res.totalLength / rollLength);

            return res;
        };

        const showResultMessage = (message) => {

            $('.form-submission-text h4').text(message);
            $('.form-submission-text').removeClass('hidden');
        };

        const showResults = (results) => {

            console.log('Results: ', results);
            if (results.error) {
                showResultMessage('Fiddlesticks! something seems to be amiss');
                results.error.addClass('error');
            } else {
                showResultMessage('Approximately ' + results.rolls + ' rolls of wallpaper*');
            }

        };

        const calculate = () => {

            const results = getResults();
            showResults(results);
        };

        if (FORM) {

            // Events
            INPUT_UNITS.change(() => {

                replaceUnits(INPUT_UNITS.val());
            });
            INPUT_BUTTON.click((e) => {

                e.preventDefault();
                $('.error').removeClass('error');
                calculate();
            });
            FORM.on('submit', (e) => e.preventDefault());

            // Initialization
            const paramWidth = params.get(PARAM_ROLL_WIDTH);
            if (paramWidth && !isNaN(paramWidth) && parseInt(paramWidth) > 0) {
                if(parseInt(paramWidth) !== DEFAULT_ROLL_WIDTH){
                    INPUT_ROLL_WIDTH.val(displayNumber(parseFloat(paramWidth)));
                }
            }
            if (parseInt(INPUT_ROLL_WIDTH.val()) === DEFAULT_ROLL_WIDTH) {
                TEXT_DISCLAIMER.append('<p>Please note: you will need to order an even number of ' +
                    'rolls as we only sell single width (26”) rolls in multiples of 2. Please round up ' +
                    'accordingly when purchasing.</p><p></p>');
            }
            TEXT_DISCLAIMER.append('<p>*This wallcovering calculator is intended to provide an approximation ' +
                '<span style="text-decoration:underline;">only</span>. We recommend consulting with a ' +
                'decorator or professional installer before purchasing any wallcoverings from our website. ' +
                'Fine &amp; Dandy Co, is not responsible for any overage or shortage resulting from the ' +
                'calculator\'s estimations. Inevitably, gabbing with an expert makes all the difference, dears!</p>');
            INPUT_UNITS.change();
        }
    });
